
import TableList from "@components/templates/tablelist";
import { HttpGetPoAmazonList,HttpReContentSku,HttpCancelPoAmazon } from "@/service/purchase/purchase";
import {
    HttpAccountAllList
} from "@/service/boss/dictionary";
import { mapState,mapGetters } from "vuex";
import comIndex from './update'
import compSelfUpload from "./compupload";

export default {
    mixins: [TableList],
    components: {
        comIndex,
        compSelfUpload,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    
                },
                sord: "updatedAt"
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            accountList: []
        }
    },
    created () {
        HttpAccountAllList().then(res => {
            this.accountList = res.data.map(item => ({
                value: item.id,
                label: `${item.title}(${item.flag})`,
                attach: {
                    ...item
                }
            }));
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpGetPoAmazonList,
        interceptRequest(params){
            
            if(params.search.EQ_checksku == true){
                params.search.EQ_productChannelId = 0;
            }
            if(params.search.EQ_checksku == false){
                params.search.EQ_productChannelId = '';
            }
            delete params.search.EQ_checksku;
            this.formData = params;
            return params;
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'oneinventoryUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case 'batchImport':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        width: 530,
                        showFooter: false,
                        name: "excelFile",
                        component: "compSelfUpload",
                        actionurl:process.env.VUE_APP_APIURL_BOSS+'/api/v2/forecastInventoryPlan/import',
                        
                    };
                    break;
                case 'recontentsku':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "重新关联ERPSKU",
                        desc:'ASIN未匹配上ERP SKU的条目，将重新匹配！',
                        width: 460,
                        ajaxRequest: HttpReContentSku
                    };
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "删除",
                        width: 460,
                        params: {
                            ids: params,
                        },
                        ajaxRequest: HttpCancelPoAmazon
                    };
                    break;
                case 'importExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/forecastInventoryPlan/export',  {...this.formData,"search[EQ_status]":1}, {
                        executor: 'request', 
                        download: true,
                    }).catch(err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id,status } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query',
            }]
        },
    },
    computed: {
        ...mapGetters('diction',['getNewAccountList','getNewAccountIdList','getNewAllAccountIdList','getNewProductList']),
        ...mapState('boss', ['accountTypes']),
        getAllAccountList(){
            return this.accountList.filter(function(item){
                
                return item.attach.type == 'amazonvendor'
            })
        },
        getChooseAccountList(){
            return this.getNewAccountIdList.filter(function(item){
                return item.attach.item.type == 'amazonvendor'
            })
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "导入",
                    operate: "batchImport",
                    theme: "primary",
                },
                {
                    name: "重新关联ERPSKU",
                    theme: 'info',
                    operate: 'recontentsku',
                },
                {
                    name: "删除",
                    theme: 'error',
                    operate: 'delete',
                    batch:true,
                },
                {
                    name: "查询条件导出",
                    theme: 'success',
                    operate: 'importExcel',
                },

            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            let widthStyle = 'width: 200px'
            return  [

                {
                    label: "Account",
                    tag: 'vSelect',
                    key: 'IN_accountFlag',
                    options: this.getAllAccountList.map(item=>{
                        return {
                            value:item.attach.flag,
                            label:item.label
                        }
                    }),
                    props:{
                        filterable:true,
                        multiple: true,
                    },
                    show:true,
                },
                {
                    label: "ASIN",
                    tag: 'vInput',
                    key: 'CN_asin',
                    show:true,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: "EQ_erpSku",
                    show: true,
                },
                
                {
                    label: "Product Title",
                    tag: 'vInput',
                    key: 'CN_productTitle',
                    style: widthStyle
                },
                {
                    label: "Replenishment Category",
                    tag: 'vSelect',
                    key: 'IN_replenishment_category',
                    options: [
                        {label:'Planned Replenishment',value:'Planned Replenishment'},
                        {label:'New Product',value:'New Product'},
                        {label:'Dropship',value:'Dropship'},
                        {label:'Non-Replenishable',value:'Non-Replenishable'},
                        {label:'Obsolete',value:'Obsolete'},
                        {label:'Off Season',value:'Off Season'},
                        {label:'Active',value:'Active'},
                        {label:'Not Yet Published',value:'Not Yet Published'},
                    ],
                    props:{
                        filterable:true,
                        clearable:true,
                        multiple:true,
                    },
                },
                
                {
                    label: "平台库存日期",
                    tag: 'vDatepicker',
                    key: 'BT_inventoryTime',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "项目",
                    tag: 'Select',
                    key: 'IN_lineId',
                    options: this.getNewProductList,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "更新时间",
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label:'只展示未关联ERPKU的条目',
                    tag:'vCheckBox',
                    key:'EQ_checksku'
                }
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes
            }, 
            {
                title: '编号',
                width: 60,
                key:'id',
            }, 
            {
                title: 'ERPSKU',
                width: 150,
                key:'erpSku',
            },
            {
                title: 'Seller SKU',
                width: 150,
                key:'sellerSku',
            },
            {
                title: 'Account',
                width: 150,
                key:'accountFlag',
                // render:(h,{row})=>this.findRenderLabel(this.getRecommendStatus,row.status,'label',true)
                
            },
            {
                title: 'ASIN',
                width: 150,
                key:'asin',
            },
            
            {
                title: 'Title',
                width: 150,
                key:'productTitle',
            },
            {
                title: 'Replenishment Category',
                width: 150,
                key:'replenishment_category',
            },
            {
                title: 'Avaliable Inventory',
                width: 150,
                key:'availableInventory',
            },
            {
                title: 'Open Purchase Order Quantity',
                width: 150,
                key:'openPurchaseOrderQuantity'
            },
            {
                title: 'Inventory Date',
                width: 150,
                key:'inventoryTime',
                sortable: true
            },
            {
                title: 'Create Time',
                width: 150,
                key: 'createdAt',
                sortable: true
            },
            {
                title: 'Update Time',
                width: 150,
                key: 'updatedAt',
                sortable: true
            },
            {
                title: 'week1',
                width: 60,
                key: 'week1',
                sortable: true
            },
            {
                title: 'week2',
                width: 60,
                key: 'week2',
                sortable: true
            },
            {
                title: 'week3',
                width: 60,
                key: 'week3',
                sortable: true
            },
            {
                title: 'week4',
                width: 60,
                key: 'week4',
                sortable: true
            },
            {
                title: 'week5',
                width: 60,
                key: 'week5',
                sortable: true
            },
            {
                title: 'week6',
                width: 60,
                key: 'week6',
                sortable: true
            },
            {
                title: 'week7',
                width: 60,
                key: 'week7',
                sortable: true
            },
            {
                title: 'week8',
                width: 60,
                key: 'week8',
                sortable: true
            },
            {
                title: 'week9',
                width: 60,
                key: 'week9',
                sortable: true
            },
            {
                title: 'week10',
                width: 60,
                key: 'week10',
                sortable: true
            },
            {
                title: 'week11',
                width: 60,
                key: 'week11',
                sortable: true
            },
            {
                title: 'week12',
                width: 60,
                key: 'week12',
                sortable: true
            },
            {
                title: 'week13',
                width: 60,
                key: 'week13',
                sortable: true
            },
            {
                title: 'weekMean1',
                width: 60,
                key: 'weekMean1',
                sortable: true
            },
            {
                title: 'weekMean2',
                width: 60,
                key: 'weekMean2',
                sortable: true
            },
            {
                title: 'weekMean3',
                width: 60,
                key: 'weekMean3',
                sortable: true
            },
            {
                title: 'weekMean4',
                width: 60,
                key: 'weekMean4',
                sortable: true
            },
            {
                title: 'weekMean5',
                width: 60,
                key: 'weekMean5',
                sortable: true
            },
            {
                title: 'weekMean6',
                width: 60,
                key: 'weekMean6',
                sortable: true
            },
            {
                title: 'weekMean7',
                width: 60,
                key: 'weekMean7',
                sortable: true
            },
            {
                title: 'weekMean8',
                width: 60,
                key: 'weekMean8',
                sortable: true
            },
            {
                title: 'weekMean9',
                width: 60,
                key: 'weekMean9',
                sortable: true
            },
            {
                title: 'weekMean10',
                width: 60,
                key: 'weekMean10',
                sortable: true
            },
            {
                title: 'weekMean11',
                width: 60,
                key: 'weekMean11',
                sortable: true
            },
            {
                title: 'weekMean12',
                width: 60,
                key: 'weekMean12',
                sortable: true
            },
            {
                title: 'weekMean13',
                width: 60,
                key: 'weekMean13',
                sortable: true
            },
            {
                title: 'weekMean14',
                width: 60,
                key: 'weekMean14',
                sortable: true
            },
            {
                title: 'weekMean15',
                width: 60,
                key: 'weekMean15',
                sortable: true
            },
            {
                title: 'weekMean16',
                width: 60,
                key: 'weekMean16',
                sortable: true
            },
            {
                title: 'weekMean17',
                width: 60,
                key: 'weekMean17',
                sortable: true
            },
            {
                title: 'weekMean18',
                width: 60,
                key: 'weekMean18',
                sortable: true
            },
            {
                title: 'weekMean19',
                width: 60,
                key: 'weekMean19',
                sortable: true
            },
            {
                title: 'weekMean20',
                width: 60,
                key: 'weekMean20',
                sortable: true
            },
            {
                title: 'weekMean21',
                width: 60,
                key: 'weekMean21',
                sortable: true
            },
            {
                title: 'weekMean22',
                width: 60,
                key: 'weekMean22',
                sortable: true
            },
            {
                title: 'weekMean23',
                width: 60,
                key: 'weekMean23',
                sortable: true
            },
            {
                title: 'weekMean24',
                width: 60,
                key: 'weekMean24',
                sortable: true
            },
            {
                title: 'weekMean25',
                width: 60,
                key: 'weekMean25',
                sortable: true
            },
            {
                title: 'weekMean26',
                width: 60,
                key: 'weekMean26',
                sortable: true
            },
            {
                title: 'weekP701',
                width: 60,
                key: 'weekP701',
                sortable: true
            },
            {
                title: 'weekP702',
                width: 60,
                key: 'weekP702',
                sortable: true
            },
            {
                title: 'weekP703',
                width: 60,
                key: 'weekP703',
                sortable: true
            },
            {
                title: 'weekP704',
                width: 60,
                key: 'weekP704',
                sortable: true
            },
            {
                title: 'weekP705',
                width: 60,
                key: 'weekP705',
                sortable: true
            },
            {
                title: 'weekP706',
                width: 60,
                key: 'weekP706',
                sortable: true
            },
            {
                title: 'weekP707',
                width: 60,
                key: 'weekP707',
                sortable: true
            },
            {
                title: 'weekP708',
                width: 60,
                key: 'weekP708',
                sortable: true
            },
            {
                title: 'weekP709',
                width: 60,
                key: 'weekP709',
                sortable: true
            },
            {
                title: 'weekP801',
                width: 60,
                key: 'weekP801',
                sortable: true
            },
            {
                title: 'weekP802',
                width: 60,
                key: 'weekP802',
                sortable: true
            },
            {
                title: 'weekP803',
                width: 60,
                key: 'weekP803',
                sortable: true
            },
            {
                title: 'weekP804',
                width: 60,
                key: 'weekP804',
                sortable: true
            },
            {
                title: 'weekP805',
                width: 60,
                key: 'weekP805',
                sortable: true
            },
            {
                title: 'weekP806',
                width: 60,
                key: 'weekP806',
                sortable: true
            },
            {
                title: 'weekP807',
                width: 60,
                key: 'weekP807',
                sortable: true
            },
            {
                title: 'weekP808',
                width: 60,
                key: 'weekP808',
                sortable: true
            },
            {
                title: 'weekP809',
                width: 60,
                key: 'weekP809',
                sortable: true
            },
            {
                title: 'weekP901',
                width: 60,
                key: 'weekP901',
                sortable: true
            },
            {
                title: 'weekP902',
                width: 60,
                key: 'weekP902',
                sortable: true
            },
            {
                title: 'weekP903',
                width: 60,
                key: 'weekP903',
                sortable: true
            },
            {
                title: 'weekP904',
                width: 60,
                key: 'weekP904',
                sortable: true
            },
            {
                title: 'weekP905',
                width: 60,
                key: 'weekP905',
                sortable: true
            },
            {
                title: 'weekP906',
                width: 60,
                key: 'weekP906',
                sortable: true
            },
            {
                title: 'weekP907',
                width: 60,
                key: 'weekP907',
                sortable: true
            },
            {
                title: 'weekP908',
                width: 60,
                key: 'weekP908',
                sortable: true
            },
            {
                title: 'weekP909',
                width: 60,
                key: 'weekP909',
                sortable: true
            },
            {
                title: 'weekP7010',
                width: 60,
                key: 'weekP7010',
                sortable: true
            },
            {
                title: 'weekP7011',
                width: 60,
                key: 'weekP7011',
                sortable: true
            },
            {
                title: 'weekP7012',
                width: 60,
                key: 'weekP7012',
                sortable: true
            },
            {
                title: 'weekP7013',
                width: 60,
                key: 'weekP7013',
                sortable: true
            },
            {
                title: 'weekP7014',
                width: 60,
                key: 'weekP7014',
                sortable: true
            },
            {
                title: 'weekP7015',
                width: 60,
                key: 'weekP7015',
                sortable: true
            },
            {
                title: 'weekP7016',
                width: 60,
                key: 'weekP7016',
                sortable: true
            },
            {
                title: 'weekP7017',
                width: 60,
                key: 'weekP7017',
                sortable: true
            },
            {
                title: 'weekP7018',
                width: 60,
                key: 'weekP7018',
                sortable: true
            },
            {
                title: 'weekP7019',
                width: 60,
                key: 'weekP7019',
                sortable: true
            },
            {
                title: 'weekP7020',
                width: 60,
                key: 'weekP7020',
                sortable: true
            },
            {
                title: 'weekP7021',
                width: 60,
                key: 'weekP7021',
                sortable: true
            },
            {
                title: 'weekP7022',
                width: 60,
                key: 'weekP7022',
                sortable: true
            },
            {
                title: 'weekP7023',
                width: 60,
                key: 'weekP7023',
                sortable: true
            },
            {
                title: 'weekP7024',
                width: 60,
                key: 'weekP7024',
                sortable: true
            },
            {
                title: 'weekP7025',
                width: 60,
                key: 'weekP7025',
                sortable: true
            },
            {
                title: 'weekP7026',
                width: 60,
                key: 'weekP7026',
                sortable: true
            },

            {
                title: 'weekP8010',
                width: 60,
                key: 'weekP8010',
                sortable: true
            },
            {
                title: 'weekP8011',
                width: 60,
                key: 'weekP8011',
                sortable: true
            },
            {
                title: 'weekP8012',
                width: 60,
                key: 'weekP8012',
                sortable: true
            },
            {
                title: 'weekP8013',
                width: 60,
                key: 'weekP8013',
                sortable: true
            },
            {
                title: 'weekP8014',
                width: 60,
                key: 'weekP8014',
                sortable: true
            },
            {
                title: 'weekP8015',
                width: 60,
                key: 'weekP8015',
                sortable: true
            },
            {
                title: 'weekP8016',
                width: 60,
                key: 'weekP8016',
                sortable: true
            },
            {
                title: 'weekP8017',
                width: 60,
                key: 'weekP8017',
                sortable: true
            },
            {
                title: 'weekP8018',
                width: 60,
                key: 'weekP8018',
                sortable: true
            },
            {
                title: 'weekP8019',
                width: 60,
                key: 'weekP8019',
                sortable: true
            },
            {
                title: 'weekP8020',
                width: 60,
                key: 'weekP8020',
                sortable: true
            },
            {
                title: 'weekP8021',
                width: 60,
                key: 'weekP8021',
                sortable: true
            },
            {
                title: 'weekP8022',
                width: 60,
                key: 'weekP8022',
                sortable: true
            },
            {
                title: 'weekP8023',
                width: 60,
                key: 'weekP8023',
                sortable: true
            },
            {
                title: 'weekP8024',
                width: 60,
                key: 'weekP8024',
                sortable: true
            },
            {
                title: 'weekP8025',
                width: 60,
                key: 'weekP8025',
                sortable: true
            },
            {
                title: 'weekP8026',
                width: 60,
                key: 'weekP8026',
                sortable: true
            },

            {
                title: 'weekP9010',
                width: 60,
                key: 'weekP9010',
                sortable: true
            },
            {
                title: 'weekP9011',
                width: 60,
                key: 'weekP9011',
                sortable: true
            },
            {
                title: 'weekP9012',
                width: 60,
                key: 'weekP9012',
                sortable: true
            },
            {
                title: 'weekP9013',
                width: 60,
                key: 'weekP9013',
                sortable: true
            },
            {
                title: 'weekP9014',
                width: 60,
                key: 'weekP9014',
                sortable: true
            },
            {
                title: 'weekP9015',
                width: 60,
                key: 'weekP9015',
                sortable: true
            },
            {
                title: 'weekP9016',
                width: 60,
                key: 'weekP9016',
                sortable: true
            },
            {
                title: 'weekP9017',
                width: 60,
                key: 'weekP9017',
                sortable: true
            },
            {
                title: 'weekP9018',
                width: 60,
                key: 'weekP9018',
                sortable: true
            },
            {
                title: 'weekP9019',
                width: 60,
                key: 'weekP9019',
                sortable: true
            },
            {
                title: 'weekP9020',
                width: 60,
                key: 'weekP9020',
                sortable: true
            },
            {
                title: 'weekP9021',
                width: 60,
                key: 'weekP9021',
                sortable: true
            },
            {
                title: 'weekP9022',
                width: 60,
                key: 'weekP9022',
                sortable: true
            },
            {
                title: 'weekP9023',
                width: 60,
                key: 'weekP9023',
                sortable: true
            },
            {
                title: 'weekP9024',
                width: 60,
                key: 'weekP9024',
                sortable: true
            },
            {
                title: 'weekP9025',
                width: 60,
                key: 'weekP9025',
                sortable: true
            },
            {
                title: 'weekP9026',
                width: 60,
                key: 'weekP9026',
                sortable: true
            },
            {
                title: 'weeksOnHand',
                width: 60,
                key: 'weeksOnHand',
                sortable: true
            },

        ];
        },
        
    },

};
